import { useState, FC, useRef } from 'react';
import { useUpdateTaskDeadlineMutation } from '../../api/tenders';
import { tenderDataProps } from '../../pages/TenderViewPage/types';
import { Button, Tooltip, message, Modal } from 'antd';
import { useAppSelector } from '../../hooks';

import arrow from '../../assets/arrow-right-white.svg';
import attention from '../../assets/attention.svg';

import moment from 'moment';
import './phases.scss';
import { TaskDeadlineModal } from '../Modals/TaskDeadline';
import { PitchAvailabilityForm } from './EvaluatePhaseComponent/PitchAvailabilityForm';
import { SupplierListNew } from './DesignPhaseComponents/SupplierListNew';
import { CompletionResultModal } from '../Modals/CompletionResultModal';

interface PropsPhase {
    data: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Evaluate12: FC<PropsPhase> = ({ data, setTrigger, setConfirmModal }) => {
    const { role } = useAppSelector((state) => state.profileReducer);
    const [screenWidth, setScreenWidth] = useState<number>(window.screen.width);
    function handleResize() {
        setScreenWidth(window.screen.width);
    }
    window.addEventListener('resize', handleResize);
    const [deadlineModal, setDeadlineModal] = useState(false);
    const [SelectedDate, setSelectedDate] = useState<Date | string>(new Date());
    const [MinSlotsModal, setMinSlotsModal] = useState(false);
    const [isPitchModal, setIsPitchModal] = useState(false);
    const [completionModalOpen, setCompletionModalOpen] = useState(false);
    const pendingAfterCompletionRef = useRef<'minSlots' | 'confirm' | null>(null);

    const [updateDeadline, { isLoading }] = useUpdateTaskDeadlineMutation();

    const updateDeadlineFunc = async () => {
        try {
            const formData = {
                id: data.id,
                data: { deadline_at: moment(SelectedDate).format('YYYY-MM-DD') }
            };
            await updateDeadline(formData).unwrap();
            await setDeadlineModal(false);
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    const [messageApi, contextHolder] = message.useMessage();

    const addBusinessDays = (startDate: Date, days: number): Date => {
        const result = new Date(startDate);
        let addedDays = 0;

        while (addedDays < days) {
            result.setDate(result.getDate() + 1);

            const day = result.getDay();
            const isWeekend = day === 0 || day === 6;

            if (!isWeekend) {
                addedDays++;
            }
        }

        return result;
    };

    const parseDate = (date: string): Date => {
        const [y, m, d] = date.split('-').map(Number);
        return new Date(y, m - 1, d);
    };

    const hasSlotsEarlierThan7BusinessDays = (slots: any[]): boolean => {
        const today = new Date();
        const minAllowedDate = addBusinessDays(today, 6);

        return slots?.some((slot) => {
            const slotDate = parseDate(slot.date);
            return slotDate < minAllowedDate;
        });
    };

    const slots = data?.phase_tasks?.find((elem) => elem.action === 'supplier_pitch_availability_form')?.slots;

    const shortlistedSuppliersCount = data?.suppliers?.filter((elem) => elem.status === 'shortlisted')?.length ?? 0;

    const slotsCount =
        data?.phase_tasks?.find((elem) => elem.action === 'supplier_pitch_availability_form')?.slots?.length ?? 0;

    const isMismatch = shortlistedSuppliersCount > slotsCount;

    const taskHeaderDeadlineAt = role === 'school_user' ? data?.tasks_deadline_at : data?.phase_deadline_at;

    return (
        <>
            {contextHolder}
            <div className={`tendermain__block tasks`}>
                <div className="tasks__header define">
                    <div className="count-wrapper">
                        Task Centre
                        <div className="count">{data?.phase_task_count}</div>
                    </div>
                    {taskHeaderDeadlineAt && (
                        <div className="tasks__deadline-wrapper">
                            <img src={attention} alt="" />
                            Task Deadline - {moment(taskHeaderDeadlineAt).format('YYYY-MM-DD')}
                        </div>
                    )}
                </div>

                <div className="tasks__list">
                    {role !== 'school_user' && data?.tasks_deadline_at && (
                        <div className="tasks__info-wrap info-wrap" style={{ margin: '0 0 16px 0' }}>
                            <div className="info-wrap__deadline">Task Deadline for Buyer</div>
                            <div className="info-wrap__status">
                                {moment(data?.tasks_deadline_at).format('YYYY-MM-DD')}
                            </div>
                        </div>
                    )}

                    <SupplierListNew data={data} role={role} messageApi={messageApi} setTrigger={setTrigger} />
                    <PitchAvailabilityForm
                        data={data}
                        role={role}
                        messageApi={messageApi}
                        setTrigger={setTrigger}
                        setIsPitchModal={setIsPitchModal}
                        isPitchModal={isPitchModal}
                    />
                </div>

                {role === 'school_user' && data.phase_tasks.length > 0 && (
                    <div className="tasks__btn-wrap">
                        <div></div>

                        <Tooltip
                            title={
                                isMismatch
                                    ? 'The number of slots cannot be less than the number of shortlisted suppliers. Please add additional slots to proceed'
                                    : data?.can_update_phase
                                    ? ''
                                    : 'To send this task, you need to complete all the Task Activities'
                            }
                            overlayClassName={` ${
                                !data?.can_update_phase || isMismatch ? 'custom-tooltip-disabled' : 'custom-tooltip'
                            }`}
                        >
                            <Button
                                className={`tasks__next-btn ${
                                    isMismatch ? 'disabled' : data?.can_update_phase ? '' : 'disabled'
                                }`}
                                type="primary"
                                onClick={() => {
                                    if (isMismatch) return;
                                    if (data?.can_update_phase) {
                                        pendingAfterCompletionRef.current = hasSlotsEarlierThan7BusinessDays(slots)
                                            ? 'minSlots'
                                            : 'confirm';
                                        setCompletionModalOpen(true);
                                    }
                                }}
                                style={{ width: '180px' }}
                            >
                                Notify Suppliers <img src={arrow} />
                            </Button>
                        </Tooltip>
                    </div>
                )}
            </div>
            {deadlineModal && (
                <TaskDeadlineModal
                    openModal={deadlineModal}
                    setOpenModal={setDeadlineModal}
                    SelectedDate={SelectedDate}
                    setSelectedDate={setSelectedDate}
                    updateDeadlineFunc={updateDeadlineFunc}
                    isLoading={isLoading}
                    data={data}
                />
            )}
            {completionModalOpen && (
                <CompletionResultModal
                    openModal={completionModalOpen}
                    setOpenModal={setCompletionModalOpen}
                    data={data}
                    setTrigger={setTrigger}
                    onAcknowledge={() => {
                        const next = pendingAfterCompletionRef.current;
                        pendingAfterCompletionRef.current = null;
                        if (next === 'minSlots') setMinSlotsModal(true);
                        else if (next === 'confirm') setConfirmModal(true);
                    }}
                />
            )}
            {MinSlotsModal && (
                <Modal
                    className="confirmModal"
                    centered
                    open={MinSlotsModal}
                    closeIcon={<div style={{ display: 'none', cursor: 'context-menu' }}></div>}
                    width={600}
                    footer={
                        <div
                            style={{
                                display: 'flex',
                                justifyItems: 'space-between',
                                gap: '16px',
                                width: '100%',
                                margin: '20px 0 0 0'
                            }}
                        >
                            <Button block key="back" onClick={() => setMinSlotsModal(false)} className="cancel">
                                Cancel
                            </Button>
                            <Button
                                form="schoolForm"
                                type="primary"
                                block
                                onClick={() => {
                                    setMinSlotsModal(false);
                                    setIsPitchModal(true);
                                }}
                            >
                                Update Date
                            </Button>
                        </div>
                    }
                >
                    <div className="modal">
                        <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                            <div className="main__title" style={{ margin: '0 0 6px 0', textAlign: 'start' }}>
                                <div>
                                    <div className="main__title-no-head">Minimum scheduling notice required</div>
                                </div>
                                Pitch meetings must be scheduled at least 7 working days in advance to allow sufficient
                                preparation time.
                                <br />
                                <br />
                                Your selected date does not meet this requirement. Please choose a later date.
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};
